import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { WidgetLayoutService } from '@fi-shared/widget/widget-layout.service';
import { WidgetAdministrateModel } from '@fi-app/widget/model/widget-administrate.model';
import { IWidgetLayout } from '@fi-shared/widget/widget';

@Component({
    selector: 'fi-appearance-start-page-edit-select-layout',
    templateUrl: './select-layout.component.html',
    styleUrls: ['./select-layout.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-appearance-start-page-edit-select-layout' },
    standalone: false,
})
export class FiAppearanceStartPageEditSelectLayoutComponent implements OnInit {
    @Input() widgetAdministrate: WidgetAdministrateModel;

    layouts: IWidgetLayout[];

    constructor(private widgetLayoutService: WidgetLayoutService) {}

    ngOnInit() {
        this.setLayouts();
    }

    selectLayout(layout: IWidgetLayout) {
        this.widgetAdministrate.SetLayout(layout);
    }

    private setLayouts() {
        this.layouts = this.widgetLayoutService.getAllLayouts();
    }
}
